import React, { Component, Fragment } from "react";
import { render } from "react-dom";
import DropdownTreeSelect from "react-dropdown-tree-select";
import isEqual from 'lodash/isEqual'

const assignObjectPaths = (obj, stack) => {
  Object.keys(obj).forEach(k => {
    const node = obj[k];
    if (typeof node === "object") {
      node.path = stack ? `${stack}.${k}` : k;
      assignObjectPaths(node, node.path);
    }
  });
};
const onChange = (currentNode, selectedNodes) => {
  
  // (selectedNodes)=> this.props.selectedCustomers(selectedNodes)
  // this.props.selectedCustomers(selectedNodes)
};
class App extends Component{
  constructor(props){
    super(props);
    this.state = { data : this.props.customerInfo }
  }
    componentWillReceiveProps = (nextProps)=>{        
        if(!isEqual(nextProps.customerInfo, this.state.data)) {
        this.setState({ data: nextProps.customerInfo })
      }
    }
    shouldComponentUpdate = (nextProps) => {
      return !isEqual(nextProps.customerInfo, this.state.data)
    }
    getCustomer = selectedNodes =>{
      this.props.selectedCustomers(selectedNodes)
    }
    render(){
      if(this.state.data !== undefined ){
        return (
          <DropdownTreeSelect
            data={this.state.data}
            onChange={this.props.selectedCustomers}
            className="bootstrap-demo"
          />
          
        );
      }
     
      else return ''
    
    }
    
  
};
export default App;
























// import React from "react";
// import { render } from "react-dom";
// import DropdownTreeSelect from "react-dropdown-tree-select";

// const onChange = (currentNode, selectedNodes) => {
//   
// };

// const assignObjectPaths = (obj, stack) => {
//   Object.keys(obj).forEach(k => {
//     const node = obj[k];
//     if (typeof node === "object") {
//       node.path = stack ? `${stack}.${k}` : k;
//       assignObjectPaths(node, node.path);
//     }
//   });
// };

// export default function App(props) {
//   if(props.customerInfo !== undefined){
//       assignObjectPaths(props.customerInfo);
//       return (
//         <DropdownTreeSelect
//           data={props.customerInfo}
//           onChange={props.selectedCustomers}
//           className="bootstrap-demo"
//           value={props.customerChoosen}
//         />
//       );
//   }
//   else return '';
// };






























// WEBPACK FOOTER //
// ./src/pages/report/multiSelect.js